import { render } from "./PropertyList.vue?vue&type=template&id=27a90713&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"

import "./PropertyList.vue?vue&type=style&index=0&id=27a90713&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27a90713"

export default script